<script setup lang="ts">
import { AvailabilityType } from "../types";
import moment from "@/date";

const props = defineProps<{
  type: AvailabilityType;
  noticePeriodDays?: number;
  availabilityDate?: string;
}>();

const formatAvailabilityDate = (date?: string): string => {
  return date ? moment(date).format("MMM D, YYYY") : "";
};
</script>

<template>
  <div class="availability-badge" role="status">
    <span class="availability-dot"></span>
    <span class="availability-copy">
      <span class="availability-label">{{
        type === "immediate" ? "Available" : type === "date" ? "Available from" : "Available in"
      }}</span>
      <span v-if="type === 'date'" class="availability-date">{{
        formatAvailabilityDate(availabilityDate)
      }}</span>
      <span v-if="type === 'notice_period'" class="availability-date"
        >{{ noticePeriodDays }} Days</span
      >
      <span v-if="type === 'immediate'" class="availability-date">Today</span>
    </span>
  </div>
</template>

<style scoped>
.availability-badge {
  width: auto;
  white-space: nowrap;
  display: inline-flex;
  align-items: center;
  gap: 11px;
  padding: 10px 14px 10px 12px;

  background: rgba(18, 18, 18, 0.96);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 14px;

  box-shadow:
    0 14px 28px rgba(0, 0, 0, 0.35),
    inset 0 1px 0 rgba(255, 255, 255, 0.035);

  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);

  font-family:
    Inter,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    sans-serif;
}

.availability-dot {
  width: 8px;
  height: 8px;
  flex: 0 0 auto;

  border-radius: 999px;
  background: #a5b69d;

  box-shadow: 0 0 0 4px rgba(165, 182, 157, 0.12);
}

.availability-copy {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.availability-label {
  color: #858178;
  font-size: 8px;
  line-height: 1.2;
  font-weight: 500;
}

.availability-date {
  color: #f2efe7;
  font-size: 10px;
  line-height: 1.25;
  font-weight: 600;
  letter-spacing: -0.01em;
}
</style>
